import { render, staticRenderFns } from "./IrInvoiceRecordHistory.vue?vue&type=template&id=4245da0a&"
import script from "./IrInvoiceRecordHistory.vue?vue&type=script&lang=js&"
export * from "./IrInvoiceRecordHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports